import { ColorMatchingNames as s } from "./types.js";
const t = Object.fromEntries(
  Object.keys(s).map((o) => [
    o,
    `var(--${o})`
  ])
), a = (o) => Object.keys(s).map((r) => `--${r}:${o[r]};`).join("");
export {
  t as ThemeColorsProperties,
  a as buildColorsCSSVariables
};
